module.exports = __webpack_public_path__ + "img/Plan1-1.e752f4d5.jpg";